import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Products from './components/Products';
import Stylists from './components/Stylists';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import CheckoutPage from './components/CheckoutPage';
import HairPriceList from './components/HairPriceList';
import { CartProvider } from './components/CartContext';
import HairShowcase from './components/HairShowcase';
import FAQ from './components/FAQ';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import CookiesPolicy from './components/CookiesPolicy';
import CookieBanner from './components/CookieBanner';
import WhatsAppButton from './components/WhatsAppButton';
import FloatingCartButton from "./components/FloatingCartButton";
import AllProducts from './components/AllProducts'; // Add this
import Vidoes from './components/SalonVideos'; // Add this
import ShippingReturns from './components/ShippingReturns';
import TermsAndConditions from './components/TermsAndConditions';


// Universal scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Handles scrolling to sections after route change (for Navbar)
function HomePageScrollEffect() {
  const location = useLocation();
  React.useEffect(() => {
    if (location.state && location.state.scrollTo) {
      // Use two attempts for robust scrolling
      setTimeout(() => {
        const el = document.getElementById(location.state.scrollTo);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        } else {
          // Try again after a delay in case first render wasn't ready
          setTimeout(() => {
            const elAgain = document.getElementById(location.state.scrollTo);
            if (elAgain) elAgain.scrollIntoView({ behavior: "smooth" });
          }, 100);
        }
        // Clean URL
        window.history.replaceState({}, document.title, '/');
      }, 100);
    }
  }, [location]);
  return null;
}

function HomePage() {
  return (
    <>
      <HomePageScrollEffect />
      <Hero />
      <About />
      <HairShowcase />
      <Products />
      <Services />
      <Stylists />
      <Testimonials />
      <Vidoes />
      <FAQ />
    </>
  );
}

function App() {
  return (
    <CartProvider>
      <Router>
        <ScrollToTop />
        <div className="App font-inter text-dark-gray leading-relaxed pt-20" style={{ backgroundColor: '#ffffff' }}>
          <Navbar />
          <main
            className="py-12 md:py-16"
            style={{ paddingTop: "90px", backgroundColor: '#ffffff' }}
          >
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/all-products" element={<AllProducts />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/hair-price-list" element={<HairPriceList />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/cookies" element={<CookiesPolicy />} />
              <Route path="/shipping-returns" element={<ShippingReturns />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            </Routes>
          </main>
          <Footer />
          <FloatingCartButton />
          <CookieBanner />
          <WhatsAppButton />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;
